import {
    AMOUNT_SPECIAL_AUTHORIZATION_FIELD,
    AMOUNT_AVAILABLE_FIELD,
    GESTIONNAIRE_FIELD,
    GESTIONNAIRE_CODE_FIELD,
    SUPER_OPERATION_FIELD,
    SUPER_OPERATION_NAME_FIELD,
    SERVICE_PROPOSAL_AMOUNT,
    PRIMITIVE_BUDGET_AMOUNT,
    REPORTED_FIELD,
    SUPPLEMENTARY_BUDGET_AMOUNT,
    BUDGET_LINE_ID,
    ORG_CHART_FINANCE_FIELD,
    ORG_CHART_FINANCE_CODE_FIELD,
    AMOUNT_AMENDING_DECISION_FIELD,
    AMOUNT_VOTED_SUP_FIELD,
    CHAPTER_LABEL_FIELD,
    CHAPTER_FIELD,
    NATURE_LABEL_FIELD,
    NATURE_FIELD,
    FUNCTION_FIELD,
    FUNCTION_LABEL_FIELD,
    ANTENNA_NAME_FIELD,
    ANTENNA_FIELD,
    OPERATION_FIELD,
    OPERATION_NAME_FIELD,
    VOTED_FIELD,
    REALIZED_FIELD,
    MANDATED_FIELD,
    VOTED_TOTAL_FIELD,
    PERCENT_REALIZED_FIELD,
    EVOLUTION_N_N_1,
    REQUESTED_FIELD,
    AGG_STATUS,
    SIMULATED_ARBITRATED_AMOUNT,
    ANALYTIC_FIELD,
    LINE_CODE_FIELD,
    BUDGET_LINE_CODE,
    ANALYTIC_NAME_FIELD,
    AMOUNT_ENGAGED_UNPAID,
    SUPER_GESTIONNAIRE_FIELD,
    SUPER_GESTIONNAIRE_CODE_FIELD,
    OPERATION_SEGMENT_NAME,
    OPERATION_SEGMENT_CODE,
    AP_LABEL,
    AP_CODE,
    ANALYTIC_POST_1_NAME,
    ANALYTIC_POST_1_CODE,
    ANALYTIC_POST_2_CODE,
    ANALYTIC_POST_2_NAME,
    ANALYTIC_POST_3_CODE,
    ANALYTIC_POST_3_NAME,
    ANALYTIC_POST_4_CODE,
    ANALYTIC_POST_4_NAME,
    STRAT_FOCUS_CODE,
    STRAT_FOCUS_NAME,
    SUB_NATURE_LABEL_FIELD,
    SUB_NATURE_FIELD,
    REAL_ORDER_FIELD,
    AP_START_YEAR,
    LINE_NAME_FIELD,
    BUDGET_LINE_PROGRAM_CODE,
    BUDGET_LINE_PROGRAM_NAME,
    ENVELOPPE_CODE,
    ENVELOPPE_LABEL,
    ANALYTIC_NATURE_CODE,
    ANALYTIC_NATURE_NAME,
    DIRECTION_CODE,
    DIRECTION_LABEL,
    ARBITRAGE_DM_AMOUNT,
} from 'routes/BudgetModule/config/constants';
import { getFieldByExercice } from 'routes/BudgetModule/helpers/format';

import { ColDef } from 'ag-grid-community';
import { BudgetPhases } from 'business/constants';
import { getFieldForPhase } from 'routes/BudgetModule/shared/phases/helpers';

export const getDefaultGridColumnsOrdering = (
    exercice: number,
): ColDef['field'][] => [
    // id
    getFieldByExercice(BUDGET_LINE_ID, exercice),
    // Ventilation columns
    AGG_STATUS,
    BUDGET_LINE_PROGRAM_NAME,
    BUDGET_LINE_PROGRAM_CODE,
    ENVELOPPE_LABEL,
    ENVELOPPE_CODE,
    ANALYTIC_NATURE_NAME,
    ANALYTIC_NATURE_CODE,
    ORG_CHART_FINANCE_FIELD,
    ORG_CHART_FINANCE_CODE_FIELD,
    GESTIONNAIRE_FIELD,
    GESTIONNAIRE_CODE_FIELD,
    SUPER_GESTIONNAIRE_FIELD,
    SUPER_GESTIONNAIRE_CODE_FIELD,
    CHAPTER_LABEL_FIELD,
    CHAPTER_FIELD,
    NATURE_LABEL_FIELD,
    NATURE_FIELD,
    SUB_NATURE_LABEL_FIELD,
    SUB_NATURE_FIELD,
    FUNCTION_LABEL_FIELD,
    FUNCTION_FIELD,
    ANTENNA_NAME_FIELD,
    ANTENNA_FIELD,
    DIRECTION_LABEL,
    DIRECTION_CODE,
    OPERATION_NAME_FIELD,
    OPERATION_FIELD,
    OPERATION_SEGMENT_NAME,
    OPERATION_SEGMENT_CODE,
    AP_LABEL,
    AP_CODE,
    AP_START_YEAR,
    SUPER_OPERATION_NAME_FIELD,
    SUPER_OPERATION_FIELD,
    ANALYTIC_NAME_FIELD,
    ANALYTIC_FIELD,
    STRAT_FOCUS_NAME,
    STRAT_FOCUS_CODE,
    ANALYTIC_POST_1_NAME,
    ANALYTIC_POST_1_CODE,
    ANALYTIC_POST_2_NAME,
    ANALYTIC_POST_2_CODE,
    ANALYTIC_POST_3_NAME,
    ANALYTIC_POST_3_CODE,
    ANALYTIC_POST_4_NAME,
    ANALYTIC_POST_4_CODE,
    REAL_ORDER_FIELD,
    BUDGET_LINE_CODE,
    LINE_NAME_FIELD,
    LINE_CODE_FIELD,
    // Input amounts
    SERVICE_PROPOSAL_AMOUNT,
    SIMULATED_ARBITRATED_AMOUNT,
    PRIMITIVE_BUDGET_AMOUNT,
    SUPPLEMENTARY_BUDGET_AMOUNT,
    ARBITRAGE_DM_AMOUNT,
    // Amounts for year N
    getFieldByExercice(REPORTED_FIELD, exercice),
    getFieldByExercice(VOTED_FIELD, exercice),
    getFieldByExercice(AMOUNT_VOTED_SUP_FIELD, exercice),
    getFieldByExercice(AMOUNT_AMENDING_DECISION_FIELD, exercice),
    getFieldByExercice(AMOUNT_SPECIAL_AUTHORIZATION_FIELD, exercice),
    getFieldByExercice(AMOUNT_VOTED_SUP_FIELD, exercice),
    getFieldByExercice(VOTED_TOTAL_FIELD, exercice),
    getFieldByExercice(AMOUNT_AVAILABLE_FIELD, exercice),
    getFieldByExercice(MANDATED_FIELD, exercice),
    getFieldByExercice(AMOUNT_ENGAGED_UNPAID, exercice),
    getFieldByExercice(REALIZED_FIELD, exercice),
    getFieldByExercice(PERCENT_REALIZED_FIELD, exercice),
    // Amounts for year N-1
    getFieldByExercice(VOTED_FIELD, exercice - 1),
    getFieldByExercice(AMOUNT_VOTED_SUP_FIELD, exercice - 1),
    getFieldByExercice(AMOUNT_AMENDING_DECISION_FIELD, exercice - 1),
    getFieldByExercice(AMOUNT_SPECIAL_AUTHORIZATION_FIELD, exercice - 1),
    getFieldByExercice(AMOUNT_VOTED_SUP_FIELD, exercice - 1),
    getFieldByExercice(VOTED_TOTAL_FIELD, exercice - 1),
    getFieldByExercice(AMOUNT_AVAILABLE_FIELD, exercice - 1),
    getFieldByExercice(MANDATED_FIELD, exercice - 1),
    getFieldByExercice(AMOUNT_ENGAGED_UNPAID, exercice - 1),
    getFieldByExercice(REALIZED_FIELD, exercice - 1),
    getFieldByExercice(PERCENT_REALIZED_FIELD, exercice - 1),
    // Amounts for year N-2
    getFieldByExercice(VOTED_FIELD, exercice - 2),
    getFieldByExercice(MANDATED_FIELD, exercice - 2),
    getFieldByExercice(AMOUNT_ENGAGED_UNPAID, exercice - 2),
    getFieldByExercice(REALIZED_FIELD, exercice - 2),
    // Amounts for year N-3
    getFieldByExercice(VOTED_FIELD, exercice - 3),
    getFieldByExercice(MANDATED_FIELD, exercice - 3),
    getFieldByExercice(AMOUNT_ENGAGED_UNPAID, exercice - 3),
    getFieldByExercice(REALIZED_FIELD, exercice - 3),
    // Misc columns
    getFieldByExercice(EVOLUTION_N_N_1, exercice),
    getFieldByExercice(REQUESTED_FIELD, exercice),
];

// The default columns showing is independent from the phase and the section because
// a column that should not appear will not be returned by the getColumns
export const getDefaultGridColumnShowing = (exercice: number): string[] => [
    getFieldByExercice(BUDGET_LINE_ID, exercice),
    AGG_STATUS,
    CHAPTER_FIELD,
    CHAPTER_LABEL_FIELD,
    NATURE_FIELD,
    FUNCTION_FIELD,
    getFieldByExercice(REALIZED_FIELD, exercice - 2),
    getFieldByExercice(VOTED_FIELD, exercice - 1),
    getFieldByExercice(VOTED_TOTAL_FIELD, exercice - 1),
    getFieldByExercice(REALIZED_FIELD, exercice - 1),
    getFieldByExercice(PERCENT_REALIZED_FIELD, exercice - 1),
    getFieldForPhase(BudgetPhases.PROPOSITION_SERVICES, 'amount'),
    getFieldForPhase(BudgetPhases.ARBITRAGE, 'amount'),
    getFieldForPhase(BudgetPhases.VOTE, 'amount'),
    getFieldForPhase(BudgetPhases.SUPPLEMENTARY_BUDGET, 'amount'),
    getFieldForPhase(BudgetPhases.ARBITRAGE_DM, 'amount'),
    OPERATION_NAME_FIELD,
    getFieldByExercice(VOTED_TOTAL_FIELD, exercice),
];

export const getExcludedGridColumnFromFilterPanel = (
    exercice: number,
    isSchool: boolean,
): string[] =>
    !isSchool
        ? []
        : [
              GESTIONNAIRE_FIELD,
              GESTIONNAIRE_CODE_FIELD,
              SUPER_OPERATION_NAME_FIELD,
              SUPER_OPERATION_FIELD,
              getFieldByExercice(REPORTED_FIELD, exercice),
              getFieldByExercice(REQUESTED_FIELD, exercice),
          ];
